export const ETHAN_ALLEN_WL_SLUG = "ethan-allen";
export const DB3D_APP_FEATURE_BRANCH_WL_SLUG = "db3d-app-feature-branch";
export const ETHAN_ALLEN_PRODUCT_ID = "17836";

export class Exceptions {

  public static isWindowDraperyProduct(wlSlug: string, productId: string): boolean {
    return (wlSlug === ETHAN_ALLEN_WL_SLUG || wlSlug === DB3D_APP_FEATURE_BRANCH_WL_SLUG) && String(productId) === ETHAN_ALLEN_PRODUCT_ID;
  }
}
